/*
 * Copyright (c) 2020. Legalbird eine Marke der R&S Internet Jewels GmbH
 */

import React from "react";
import Layout from "../../../Layouts/Layout";
import { Helmet } from "react-helmet-async";
import Container from "../../../../components/Container/Container";
import Button from "@mui/material/Button";
import error404PageStyle from "./error404PageStyle";
import { Link } from "react-router";
import backgroundTeaser from "../../../../assets/img/generic/Teaser_Bird_404.jpg";
import Typography from "@mui/material/Typography";
import { Box } from "@mui/material";
import { gaSet } from "../../../../services/googleAnalyticsService";

const Error404PageService = () => {
  const title = "404 - Servicewelt | Legalbird";
  gaSet({ title: title });

  return (
    <Layout minimal={true}>
      <Helmet>
        <title>{title}</title>
      </Helmet>
      <Container sx={error404PageStyle.container}>
        <Box component={"img"} src={backgroundTeaser} alt={"Bird Teaser 404"} sx={error404PageStyle.teaserImage} />
        <Typography variant={"h3"}>Diese Seite konnte nicht gefunden werden</Typography>
        <p>
          Gründe dafür könnten sein, dass Sie eine falsche oder veraltete URL aufgerufen haben - bitte überprüfen Sie diese noch einmal. Oder aber wir haben die
          betreffende Seite archiviert, verschoben oder umbenannt.
        </p>
        <p>Vielleicht können Sie den von Ihnen gewünschten Inhalt über unsere Servicewelt finden.</p>
        <Button component={Link} to={"/servicewelt"} variant={"contained"} sx={error404PageStyle.button}>
          zur Servicewelt
        </Button>
      </Container>
      <br />
    </Layout>
  );
};

export default Error404PageService;
